module.exports = __webpack_public_path__ + "static/media/mail.a1f8e6bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/mail.png
// module id = 649
// module chunks = 0